import React from "react";
import { BulletListTypes } from "../../../types/ContentCard";
import { detectDeviceType } from "../../../utils/detectDeviceType";
import { BulletListContainer } from "./BulletListStyles";
import BulletIcon from "../../../assets/Images/Mobile/BulletIcon.png";

const BulletList: React.FC<{
  contentCardData: BulletListTypes;
  tabletLandscape: boolean;
}> = ({ contentCardData, tabletLandscape }) => {
  return (
    <BulletListContainer
      deviceType={detectDeviceType()}
      isLandscape={tabletLandscape}
      data-sm-content="bulletList"
    >
      {contentCardData.data.subHeader && (
        <h5>{contentCardData.data.subHeader}</h5>
      )}
      {contentCardData.data.bullets.map((bullet, index) => {
        return (
          <div id="list-item" key={index}>
            <img src={BulletIcon} alt="bullet" id="bullet" />
            <p>
              {bullet.text}
              {bullet.link && (
                <a
                  href={bullet.link}
                  target="_blank"
                  rel="noreferrer"
                  data-tracking={bullet.dataTracking ? bullet.dataTracking : ""}
                >
                  {bullet.linkText}
                </a>
              )}
            </p>
          </div>
        );
      })}
    </BulletListContainer>
  );
};

export default BulletList;
